/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Preview_Lock_Aria_LabelInputs */

const en_player_preview_lock_aria_label = /** @type {(inputs: Player_Preview_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview Lock`)
};

const fr_player_preview_lock_aria_label = /** @type {(inputs: Player_Preview_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrouillage de l'Apercu`)
};

const de_player_preview_lock_aria_label = /** @type {(inputs: Player_Preview_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschausperre`)
};

const it_player_preview_lock_aria_label = /** @type {(inputs: Player_Preview_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocco anteprima`)
};

const ru_player_preview_lock_aria_label = /** @type {(inputs: Player_Preview_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр блокировки`)
};

const es_player_preview_lock_aria_label = /** @type {(inputs: Player_Preview_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueo de vista previa`)
};

const zh_cn2_player_preview_lock_aria_label = /** @type {(inputs: Player_Preview_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览锁定`)
};

const ja_player_preview_lock_aria_label = /** @type {(inputs: Player_Preview_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューロック`)
};

const hi_player_preview_lock_aria_label = /** @type {(inputs: Player_Preview_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्वावलोकन लॉक`)
};

const pt_pt2_player_preview_lock_aria_label = /** @type {(inputs: Player_Preview_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueio de pré-visualização`)
};

/**
* | output |
* | --- |
* | "Preview Lock" |
*
* @param {Player_Preview_Lock_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_preview_lock_aria_label = /** @type {((inputs?: Player_Preview_Lock_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Preview_Lock_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_preview_lock_aria_label(inputs)
	if (locale === "de") return de_player_preview_lock_aria_label(inputs)
	if (locale === "it") return it_player_preview_lock_aria_label(inputs)
	if (locale === "ru") return ru_player_preview_lock_aria_label(inputs)
	if (locale === "es") return es_player_preview_lock_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_player_preview_lock_aria_label(inputs)
	if (locale === "ja") return ja_player_preview_lock_aria_label(inputs)
	if (locale === "hi") return hi_player_preview_lock_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_player_preview_lock_aria_label(inputs)
	return en_player_preview_lock_aria_label(inputs)
});